module.exports = __webpack_public_path__ + "img/boomtown-logo.c2a98842.png";